import { createContentPropTypes } from '../../../helpers/content';

const content = {
	backButtonLabel: 'Back',
	cancelButtonLabel: 'Cancel',
	closeButtonLabel: 'Close',
	cancelDirectDebitHeader: 'Cancel Direct Debit',
	cancelSchedulePaymentHeader: 'Cancel One-off payment',
	cancelStandingOrderHeader: 'Cancel standing order',
	cancelBacsPaymentHeader: 'Cancel Bacs payment',
	cancelIFTPaymentHeader: 'Cancel international payment',
	cancelCHAPSPaymentHeader: 'Cancel CHAPS payment',
	cancelBacsPaymentSubHeader: 'You’re about to cancel the following Bacs payment.',
	cancelSchedulePaymentSubHeader: 'You’re about to cancel the following One-off payment.',
	cancelStandingOrderSubHeader: 'You’re about to cancel the following standing order.',
	cancelIFTPaymentSubHeader: 'You’re about to cancel the following international payment.',
	directDebitCancelSubHeader:
		'You’re about to cancel the following Direct Debit. Before you do this, we recommend you let the organisation you’re currently paying know so they don’t try to take the money out your account.',
	cancelBacsPaymentAlert: 'You can cancel this up to 8am on the submission day.',
	cancelDirectDebitAlert:
		'You can cancel this up to 4pm on the business day before it’s due to be paid. If you cancel it after this time, the payment may still be taken.',
	cancelPaymentAlert:
		'One-off payments can be cancelled up to midnight on the business day before the payment is due to leave your account, for repeating standing orders it’s 4pm the business day before. If you cancel after this time money may still leave your account.',
	cancelIFTPaymentAlert:
		'You’re about to cancel the following payment. If you cancel it now, the payment won’t be submitted for processing and no money will leave this account.',
	cancelCHAPSPaymentAlert:
		'You’re about to cancel the following payment. If you cancel it now, the payment won’t be submitted for processing and no money will leave this account.',
	cancelDDButtonLabel: 'Cancel this Direct Debit',
	cancelSOButtonLabel: 'Cancel this standing order',
	cancelSinglePaymentLabel: 'Cancel this payment',
	cancelSingleTransferLabel: 'Cancel this transfer',
	cancelBacsPaymentLabel: 'Cancel this Bacs payment',
	cancelChapsPaymentLabel: 'Cancel this CHAPS payment',
	cancelIFTPaymentLabel: 'Cancel this international payment',
	labelOk: 'OK',
};

export const contentPropTypes = createContentPropTypes(content);

export default content;
